import { NotificationContainer } from 'react-notifications';
import { AuthProvider } from './auth';

const AppProvider = ({ children }) => (
  <AuthProvider>
    <NotificationContainer />
    {children}
  </AuthProvider>
);

export default AppProvider;
